import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import MeaPage from "../../../components/MeaPage";
import SecretariatWorkspaceBar from "../components/SecretariatWorkspaceBar";
import TrainingsListComponent from "../components/TrainingsListComponent";
import { useAuthContext } from "../../../hooks/useAuthContext";

const SecretariatAgendaListPage = () => {
  const { currentMembership } = useAuthContext();
  const navigate = useNavigate();
  const listRef = useRef();

  return (
    <MeaPage
      title="De quelle formation ?"
      breadcrumb={<SecretariatWorkspaceBar section="agenda" />}
        showBackButton={true}
        onBackButtonClick={() => navigate(`/school/${currentMembership?.school?.id}/secretariat`)}
    >
      <TrainingsListComponent ref={listRef} redirectPath="agenda" />
    </MeaPage>
  );
};

export default SecretariatAgendaListPage;
